/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Code_Execution_Execute_SuccessInputs */

const es_tools_code_execution_execute_success = /** @type {(inputs: Tools_Code_Execution_Execute_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código ejecutado`)
};

const en_tools_code_execution_execute_success = /** @type {(inputs: Tools_Code_Execution_Execute_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code executed`)
};

/**
* | output |
* | --- |
* | "Code executed" |
*
* @param {Tools_Code_Execution_Execute_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_code_execution_execute_success = /** @type {((inputs?: Tools_Code_Execution_Execute_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Code_Execution_Execute_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_code_execution_execute_success(inputs)
	return en_tools_code_execution_execute_success(inputs)
});
export { tools_code_execution_execute_success as "tools.code_execution.execute_success" }